import { useEffect } from 'react'

import { useUnit } from 'effector-react'

import { useDateRangeContext } from '@/components/provider/date-range-provider'

import {
  $filteredLeaderboardCreators,
  $isLeaderboardActivityLoading,
  $leaderboardActivityStates,
  fetchLeaderboardActivityStatesFx,
} from '../models/chatter-leaderboard'

export const useChatterLeaderboardActivityStates = () => {
  const { date: dateRange } = useDateRangeContext()
  const filteredCreators = useUnit($filteredLeaderboardCreators)
  const activityStates = useUnit($leaderboardActivityStates)
  const isLoading = useUnit($isLeaderboardActivityLoading)

  useEffect(() => {
    if (!dateRange) {
      return
    }

    const from = dateRange.from || new Date()
    const to = dateRange.to || new Date()
    const creatorIds = filteredCreators.map((creator) => creator.id)

    // Initial fetch
    fetchLeaderboardActivityStatesFx({ from, to, creatorIds })

    // Start polling (60 seconds)
    const intervalId = window.setInterval(() => {
      fetchLeaderboardActivityStatesFx({ from, to, creatorIds })
    }, 60 * 1000)

    return () => {
      window.clearInterval(intervalId)
    }
  }, [dateRange, filteredCreators])

  return {
    activityStates,
    isLoading,
  }
}
